var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopic8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87.182,
    height: 79,
    viewBox: "0 0 87.182 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 87.182,
    height: 79,
    fill: "#f7707d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825",
    transform: "translate(-994.499 -6766.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    transform: "translate(994.499 6766.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43694",
    "data-name": "Path 43694",
    d: "M396.751,248.481c-.348.55-.749,1-1.5.872s-.96-.693-1.129-1.325c-.16-.6-.384-1.184-.56-1.781a1.3,1.3,0,0,1,.746-1.75,1.264,1.264,0,0,1,1.657.911c.289.73.524,1.48.783,2.221Z",
    transform: "translate(-309.569 -192.292)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43695",
    "data-name": "Path 43695",
    d: "M44.538,93.3v6.229l6.583,1.357c1.637.338,3.277.664,4.911,1.017a1.993,1.993,0,0,1,1.808,2.121c.073,2.308.178,3.7-3.373,3.669-10.328-.078-20.658-.027-30.986-.028-2.106,0-2.727-.626-2.727-2.743,0-.341-.01-.682.007-1.021a1.91,1.91,0,0,1,1.572-1.954c1.269-.3,2.55-.543,3.831-.78a1.266,1.266,0,1,1,.535,2.466c-.934.233-1.884.4-2.824.613-.551.124-.548.137-.451.853H54.215a1.238,1.238,0,0,0,.422-.009,5.6,5.6,0,0,0,.643-.344c-.178-.164-.333-.428-.539-.477-1.268-.3-2.547-.553-3.823-.818-1.581-.328-3.154-.712-4.748-.959a32.981,32.981,0,0,0-4.049-.354c-1.928-.058-3.86-.065-5.788,0-1.379.048-2.757.219-4.127.4-1.021.138-1.721-.179-1.871-.979-.141-.75.355-1.329,1.333-1.542.72-.156,1.442-.3,2.163-.455a1.108,1.108,0,0,0,.19-.088V93.3H32.9q-13.323,0-26.645.005c-2.512,0-4.508-.906-5.616-3.228a6.506,6.506,0,0,1-.612-2.7Q-.024,64.907.013,42.433a5.882,5.882,0,0,1,6.945-5.892,1.265,1.265,0,0,1-.017,2.526c-.45.043-.908,0-1.361.031a3.171,3.171,0,0,0-3.008,3.024c-.018.283-.01.567-.01.851q0,21.963,0,43.926c0,2.685,1.142,3.83,3.829,3.831q26.432,0,52.865,0a6.084,6.084,0,0,1,1.266.1,1.125,1.125,0,0,1,.943,1.235,1.145,1.145,0,0,1-1.018,1.176,5.852,5.852,0,0,1-1.017.06q-6.9.005-13.791,0h-1.1m-7.87,6.211h5.219V93.356H36.668Z",
    transform: "translate(0 -28.695)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43696",
    "data-name": "Path 43696",
    d: "M94.98,13.943H52.866v.862q0,16.814,0,33.627c0,1.634.476,2.1,2.153,2.1q10.684,0,21.368,0c1.339,0,1.933.379,1.954,1.238.022.881-.635,1.321-1.985,1.322q-10.684,0-21.368,0c-3.092,0-4.68-1.58-4.68-4.65q0-21.879,0-43.758C50.31,1.546,51.868,0,55.027,0Q74.054,0,93.081,0c2.241,0,3.812,1.079,4.3,3a6.539,6.539,0,0,1,.152,1.6q.012,15.536,0,31.073a7.079,7.079,0,0,1-.036.764,1.161,1.161,0,0,1-1.181,1.12,1.139,1.139,0,0,1-1.266-1.013,6.451,6.451,0,0,1-.076-1.1q-.006-10.216,0-20.432Zm0-2.638c0-2.262,0-4.442,0-6.622,0-1.683-.44-2.124-2.106-2.125H71.679q-8.469,0-16.938,0c-1.335,0-1.863.532-1.874,1.854-.009,1.192,0,2.383,0,3.575V11.3Z",
    transform: "translate(-39.58 0)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43697",
    "data-name": "Path 43697",
    d: "M173.37,180.409c4.792.422,9.481.831,14.169,1.25,4.8.429,9.6.873,14.4,1.3.758.067,1.437.215,1.6,1.086s-.4,1.278-1.1,1.591c-1.757.788-3.5,1.619-5.266,2.375a2.222,2.222,0,0,0-1.209,1.2c-1.274,2.687-2.584,5.358-3.885,8.032-.67,1.376-1.3,1.544-2.527.672-1.3-.917-2.61-1.813-3.864-2.784a1.176,1.176,0,0,0-1.511-.087c-1.436.8-2.906,1.535-4.372,2.276-1.12.565-1.743.341-2.214-.813q-2.874-7.04-5.721-14.09c-.54-1.338.069-2.08,1.5-2.009m13.982,10.125-11.922-6.153,4.136,10.19,7.787-4.037M184.3,185.88l-.1.14c1.9.983,3.782,2.011,5.715,2.93,1.028.489,1.684,1.094,1.569,2.312a5.111,5.111,0,0,0,.156,1.026l1.955-4.024-9.3-2.383m5.493-1.435q0,.1.009.194,2.337.6,4.675,1.209a2.51,2.51,0,0,0,2.537-.765l-7.222-.638m-.591,10.041-.2-1.913-1.446.749,1.642,1.164",
    transform: "translate(-135.069 -141.933)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43698",
    "data-name": "Path 43698",
    d: "M302.009,65.139c0,7.376-.012,14.752.006,22.127a5.812,5.812,0,0,1-3.224,5.635,6.6,6.6,0,0,1-3.731.555,1.136,1.136,0,0,1-1.119-1.171,1.151,1.151,0,0,1,1.078-1.293c.5-.074,1.017-.052,1.525-.093a3.062,3.062,0,0,0,2.871-2.848c.026-.31.03-.623.03-.935q0-22-.01-44a5.1,5.1,0,0,0-.272-1.913,3.082,3.082,0,0,0-3.119-1.923q-5.106.009-10.213,0a3.508,3.508,0,0,1-.846-.051,1.257,1.257,0,0,1,0-2.45,3.553,3.553,0,0,1,.846-.051q4.979,0,9.957,0c3.837.005,6.209,2.353,6.216,6.2q.021,11.106,0,22.212",
    transform: "translate(-223.445 -28.892)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43699",
    "data-name": "Path 43699",
    d: "M99.063,134.339c.354-1.142.606-2.07.941-2.968.1-.258.429-.588.656-.59a.97.97,0,0,1,.668.576c.331.9.576,1.827.929,2.99.44-1.237.808-2.244,1.156-3.257.192-.56.41-1,1.147-.734s.692.736.442,1.348c-.58,1.414-1.117,2.846-1.665,4.272-.177.46-.33.92-.964.9s-.74-.51-.9-.969c-.23-.662-.477-1.319-.8-2.213a23.859,23.859,0,0,1-.851,2.281c-.174.353-.549.818-.854.835s-.758-.418-.906-.759c-.642-1.479-1.18-3-1.79-4.5-.242-.593-.147-.959.481-1.188.647-.237.937.044,1.131.628.347,1.045.73,2.077,1.182,3.351",
    transform: "translate(-75.644 -102.493)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43700",
    "data-name": "Path 43700",
    d: "M144.385,133.676c-.338.953-.562,1.74-.9,2.473a1.216,1.216,0,0,1-.809.67,1.155,1.155,0,0,1-.832-.632c-.664-1.56-1.235-3.16-1.877-4.73-.249-.609-.019-.9.522-1.1a.708.708,0,0,1,1.06.482c.373,1.09.769,2.171,1.236,3.484.3-.961.512-1.7.77-2.423.166-.465.074-1.18.859-1.159.77.021.664.743.836,1.2.261.7.444,1.43.735,2.395.451-1.253.823-2.247,1.163-3.251.192-.568.4-1,1.14-.731.689.255.7.679.461,1.277-.6,1.494-1.143,3.015-1.781,4.495a1.289,1.289,0,0,1-.883.686c-.248.02-.641-.385-.782-.688-.342-.732-.575-1.516-.916-2.452",
    transform: "translate(-110.038 -102.494)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43701",
    "data-name": "Path 43701",
    d: "M186.636,134.075c.268-.881.5-1.775.824-2.633.107-.283.46-.658.7-.656s.586.38.691.665c.32.861.546,1.758.885,2.9.45-1.24.827-2.232,1.167-3.237.19-.564.386-1.02,1.129-.76s.717.728.464,1.346c-.589,1.442-1.105,2.915-1.727,4.342-.15.344-.606.782-.9.769s-.686-.48-.857-.833a24.311,24.311,0,0,1-.849-2.3c-.338.94-.568,1.728-.91,2.463-.141.3-.516.674-.8.685a1.151,1.151,0,0,1-.847-.618c-.667-1.562-1.246-3.162-1.877-4.74-.236-.591-.03-.907.528-1.106.586-.209.9,0,1.092.571.355,1.06.744,2.108,1.119,3.16Z",
    transform: "translate(-144.47 -102.498)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43702",
    "data-name": "Path 43702",
    d: "M393.1,284.538c-1,0-1.667-.732-1.436-1.481a18.442,18.442,0,0,1,1.141-2.814,1.234,1.234,0,0,1,2.269.809,19.139,19.139,0,0,1-1.208,2.957c-.145.292-.607.426-.766.529",
    transform: "translate(-308.105 -220.005)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43703",
    "data-name": "Path 43703",
    d: "M278.847,262.824c-.289.342-.517.843-.882.98a1.479,1.479,0,0,1-1.294-.177,16.863,16.863,0,0,1-1.915-2.354,1.076,1.076,0,0,1,.229-1.459,1.02,1.02,0,0,1,1.454-.185,33.26,33.26,0,0,1,2.22,2.739c.059.076.033.219.047.331l.142.124",
    transform: "translate(-216.011 -204.078)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43704",
    "data-name": "Path 43704",
    d: "M375.4,220.358a1.238,1.238,0,0,1-1.814,1.2,12.234,12.234,0,0,1-2.4-1.983,1.482,1.482,0,0,1,0-1.426,1.453,1.453,0,0,1,1.345-.427,19.951,19.951,0,0,1,2.644,2.059c.164.14.179.455.223.577",
    transform: "translate(-291.884 -171.251)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43705",
    "data-name": "Path 43705",
    d: "M333.661,308.281c.013,1.056-.74,1.718-1.538,1.484a19.247,19.247,0,0,1-2.68-1.026,1.165,1.165,0,0,1-.585-1.584,1.113,1.113,0,0,1,1.441-.726,18.821,18.821,0,0,1,2.752,1.063c.321.156.489.624.61.789",
    transform: "translate(-258.645 -241.034)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43706",
    "data-name": "Path 43706",
    d: "M300.692,285.536a5.491,5.491,0,0,1,.968.45c.65.5,1.289,1.009,1.893,1.559a1.231,1.231,0,0,1,.208,1.8,1.268,1.268,0,0,1-1.815.152,11.939,11.939,0,0,1-1.927-1.639,1.827,1.827,0,0,1-.3-1.437c.091-.358.637-.6.971-.885",
    transform: "translate(-235.773 -224.645)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43707",
    "data-name": "Path 43707",
    d: "M368.6,309.139c-.138.176-.346.667-.711.858a14.313,14.313,0,0,1-2.518.992,1.2,1.2,0,0,1-1.581-.769,1.252,1.252,0,0,1,.831-1.626c.76-.307,1.523-.611,2.3-.878.854-.294,1.647.256,1.681,1.422",
    transform: "translate(-286.155 -242.035)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 5.219,
    height: 6.157,
    transform: "translate(36.668 64.661)",
    fill: "#f7707d",
    opacity: 0.279
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43708",
    "data-name": "Path 43708",
    d: "M104.4,20.735H62.29V17.419c0-1.191-.007-2.383,0-3.575.01-1.322.539-1.852,1.874-1.854q8.469-.009,16.937,0H102.3c1.666,0,2.1.441,2.106,2.125,0,2.18,0,4.36,0,6.622M91.6,19.67a3.213,3.213,0,0,0,3.212-3.264,3.235,3.235,0,0,0-6.469.039A3.225,3.225,0,0,0,91.6,19.67m7.713,0a3.2,3.2,0,0,0,3.223-3.247A3.25,3.25,0,0,0,99.354,13.2a3.288,3.288,0,0,0-3.282,3.23,3.233,3.233,0,0,0,3.242,3.245m-15.464,0A3.244,3.244,0,0,0,87.1,16.425a3.3,3.3,0,0,0-3.2-3.227,3.252,3.252,0,0,0-3.267,3.229,3.2,3.2,0,0,0,3.226,3.245",
    transform: "translate(-49.005 -9.431)",
    fill: "#f7707d",
    opacity: 0.279
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43716",
    "data-name": "Path 43716",
    d: "M104.4,20.735H62.29V17.419c0-1.191-.007-2.383,0-3.575.01-1.322.539-1.852,1.874-1.854q8.469-.009,16.937,0H102.3c1.666,0,2.1.441,2.106,2.125,0,2.18,0,4.36,0,6.622M91.6,19.67a3.213,3.213,0,0,0,3.212-3.264,3.235,3.235,0,0,0-6.469.039A3.225,3.225,0,0,0,91.6,19.67m7.713,0a3.2,3.2,0,0,0,3.223-3.247A3.25,3.25,0,0,0,99.354,13.2a3.288,3.288,0,0,0-3.282,3.23,3.233,3.233,0,0,0,3.242,3.245m-15.464,0A3.244,3.244,0,0,0,87.1,16.425a3.3,3.3,0,0,0-3.2-3.227,3.252,3.252,0,0,0-3.267,3.229,3.2,3.2,0,0,0,3.226,3.245",
    transform: "translate(-49 1.569)",
    fill: "#f7707d",
    opacity: 0.279
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43709",
    "data-name": "Path 43709",
    d: "M201.185,205.206l-7.787,4.037-4.136-10.19,11.922,6.153",
    transform: "translate(-148.902 -156.605)",
    fill: "#f7707d",
    opacity: 0.279
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43710",
    "data-name": "Path 43710",
    d: "M230.48,206.083l9.3,2.383-1.955,4.024a5.115,5.115,0,0,1-.156-1.026c.116-1.218-.54-1.824-1.569-2.312-1.932-.918-3.813-1.947-5.715-2.929l.1-.14",
    transform: "translate(-181.254 -162.136)",
    fill: "#f7707d",
    opacity: 0.279
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43711",
    "data-name": "Path 43711",
    d: "M256.6,199.355l7.222.638a2.511,2.511,0,0,1-2.537.765q-2.338-.6-4.675-1.209c0-.065-.006-.13-.009-.194",
    transform: "translate(-201.877 -156.842)",
    fill: "#f7707d",
    opacity: 0.288
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43712",
    "data-name": "Path 43712",
    d: "M247.767,239.382l-1.642-1.164,1.446-.749.2,1.913",
    transform: "translate(-193.639 -186.828)",
    fill: "#f7707d",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43713",
    "data-name": "Path 43713",
    d: "M187.731,24.138a3.225,3.225,0,0,1-3.257-3.225,3.235,3.235,0,0,1,6.469-.039,3.212,3.212,0,0,1-3.212,3.264m-.026-2.253c.318-.47.639-.737.63-.992-.009-.223-.441-.641-.593-.6a1.052,1.052,0,0,0-.661.656c-.045.193.3.478.624.939",
    transform: "translate(-145.135 -13.899)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43714",
    "data-name": "Path 43714",
    d: "M223.956,24.138a3.233,3.233,0,0,1-3.242-3.245A3.287,3.287,0,0,1,224,17.663a3.25,3.25,0,0,1,3.183,3.227,3.2,3.2,0,0,1-3.222,3.247m.95-3.181c-.434-.342-.712-.714-.9-.673-.272.06-.478.418-.712.649.218.212.417.563.659.6.225.03.5-.28.952-.572",
    transform: "translate(-173.646 -13.896)",
    fill: "#f7707d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43715",
    "data-name": "Path 43715",
    d: "M151.5,24.14a3.2,3.2,0,0,1-3.226-3.245,3.252,3.252,0,0,1,3.267-3.229,3.3,3.3,0,0,1,3.2,3.227A3.244,3.244,0,0,1,151.5,24.14m-.01-4.185c-.3.444-.615.706-.6.941s.367.453.571.678c.233-.228.6-.428.655-.692.041-.2-.313-.487-.629-.927",
    transform: "translate(-116.653 -13.899)",
    fill: "#f7707d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic8);
export default __webpack_public_path__ + "static/media/topic8.9ec0b8599b5e400f5cc575d8fe34a899.svg";
export { ForwardRef as ReactComponent };